<template>
    <div class="page">
        <toolbar-system :sideIcon="system.sideIcon"></toolbar-system>
        <progress-system :isLoad="system.progress"></progress-system>
        <alertbar-system v-if="system.AlertbarShow != null" :alertbar="system.AlertbarShow"></alertbar-system>
        <v-container>
            <v-card flat>
                <v-card-title>
                    <h1 class="display-1">Gestão de notificações</h1>                    
                </v-card-title>
                <v-text-field
                    v-model="search"                    
                    label="Pesquisar a turma desejada"
                    single-line
                    hide-details
                />
                <v-card-text>
                    <v-data-table
                        :headers="headers"
                        :items="cursos"
                        :search="search"
                        class="elevation-1"                        
                    >
                        <template slot="items" slot-scope="props">
                            <tr>
                                <td>{{ props.item.Descricao }} - {{ props.item.GradeDescricao }}</td>

                                <td>
                                    {{$moment(props.item.DataInicial).format('L')}}
                                </td>

                                <td>
                                    {{$moment(props.item.DataFinal).format('L')}}
                                </td>

                                <td>
                                    <v-btn
                                        small
                                        color="blue"
                                        dark
                                        @click="
                                            getTituloTurma(
                                                props.item.Descricao,
                                                props.item.GradeDescricao,
                                                props.item.IdCurso
                                            );
                                            local.openModalPushTurma = true
                                        "
                                    >
                                        <v-icon left small>
                                            mdi-bell-ring
                                        </v-icon>
                                        Nova notificação
                                    </v-btn>
                                </td>
                            </tr>
                        </template>
                    </v-data-table>
                </v-card-text>
            </v-card>
            <!-- PUSH GERAL -->
            <v-dialog v-model="local.openModalPushGeral" persistent max-width="650">
                <v-card>
                    <v-card-title class="title">Notificação Geral</v-card-title>
                    <v-card-text>
                        <v-select v-model="pushGeral.tipo" color="blue" label="Tipo" :items="pushGeralTipos"  item-text="name" item-value="value">
                        </v-select>
                        <v-select v-model="pushGeral.curso" v-if="pushGeral.tipo==='novo-curso'" color="blue" label="Curso" :items="cursos"  item-text="Descricao" item-value="IdCurso">
                            <template slot="selection" slot-scope="data">
                                {{ data.item.Descricao }} - {{ data.item.GradeDescricao }}
                            </template>
                            <template slot="item" slot-scope="data">
                                {{ data.item.Descricao }} - {{ data.item.GradeDescricao }}
                            </template>
                        </v-select>
                        <v-text-field v-model="pushGeral.titulo" color="blue" label="Titulo" :readonly="pushGeral.tipo === 'novo-curso'"></v-text-field>
                        <v-textarea v-model="pushGeral.texto"  color="blue" label="Texto" :readonly="pushGeral.tipo === 'novo-curso'">
                        </v-textarea>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn @click="resetPushGeralFields()" class="silver" large dark>
                            Cancelar
                        </v-btn>
                        <v-btn @click="canPushGeral? goPushGeral() : null " class="blue" large dark :class="{'btn-disabled': !canPushGeral}" :ripple="canPushGeral">
                            <v-icon left>mdi mdi-send</v-icon>
                            Enviar
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <!-- PUSH POR TURMA -->
            <v-dialog v-model="local.openModalPushTurma" persistent max-width="600">
                <v-card>
                    <v-card-title class="title">Notificação {{tituloCurso}}</v-card-title>
                    <v-card-text>
                        <v-text-field v-model="pushTurma.titulo" color="blue" label="Titulo"></v-text-field>
                        <v-textarea v-model="pushTurma.texto" color="blue" label="Texto"></v-textarea>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn @click="resetPushTurmaFields()" class="silver" large dark>
                            Cancelar
                        </v-btn>
                        <v-btn @click="canPushTurma? goPushTurma(idTurma) : null" class="blue" large dark>
                            <v-icon left>mdi mdi-send</v-icon>
                            Enviar
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-container>
    </div>
</template>
<script>
/*eslint-disable*/
import ToolbarSystem from '../../../components/ToolbarSystem'
import AlertbarSystem from '../../../components/AlertbarSystem'
import ProgressSystem from '../../../components/ProgressSystem'
export default {
    components:{
        ToolbarSystem,
        AlertbarSystem,
        ProgressSystem
    },
    watch:{
        'pushGeral.tipo': function (val) {
            if (val === 'novo-curso') {
                this.pushGeral.titulo = 'Novo curso!'
                this.pushGeral.texto = 'Novo curso ...'
            }
            if (val === 'custom') {
                this.pushGeral.titulo = null
                this.pushGeral.texto = null
            }
        },
        'pushGeral.curso': function(val){
            let curso = this.cursos.find(curso => curso.IdCurso === val)
            this.pushGeral.texto = `Novo curso ${curso.GradeDescricao}`
        },
    },
    computed:{
        canPushGeral(){
            if (this.pushGeral.tipo === 'novo-curso' && this.pushGeral.curso !== null) {
                return true
            }
            if (this.pushGeral.tipo === 'custom' && this.pushGeral.titulo !== null && this.pushGeral.texto !== null) {
                return true
            }
            return false
        },
        canPushTurma(){
            if (this.pushTurma.titulo !== null && this.pushTurma.texto !== null) {
                return true
            }
            return false
        },
    },
    data(){
        return{
            system:{
                sideIcon: true,
                progress: true,
                AlertbarShow: null
            },
            local:{
                openModalPushGeral: null,
                openModalPushTurma: null
            },
            cursos: [],
            tituloCurso: "",
            idTurma: null,
            pushGeral:{
                titulo: null,
	            texto: null,
	            curso: null,
                tipo: 'custom',
            },
            pushTurma:{
                titulo: null,
                texto: null
            },
            headers: [
                { text: 'Curso', value: 'Curso' },                
                { text: 'Data inicial', value: 'DataInicial' },
                { text: 'Data final', value: 'DataFinal' },
                { text: 'Ações', sortable: false }
            ],
            search: '',
            pushGeralTipos: [{name:'Customizada', value:'custom'},{name:'Novo Curso', value:'novo-curso'}]
        }
    },
    methods:{
        getCursos(){
            this.axios.get('admin/push/curso').then(res => {
                this.cursos = res.data
            }).finally(() =>{
                this.system.progress = false
            })
        },
        goPushGeral() {
            const payload = {
                titulo: this.pushGeral.titulo,
                conteudo: this.pushGeral.texto,
            }
            if(this.pushGeral.tipo === 'novo-curso'){
                payload.data = {
                    codigo: `${this.pushGeral.curso}`,
                    tipo: 'curso'
                }
            }
            this.axios.post('admin/push/onesignal', payload).then(res => {
                this.system.AlertbarShow = {
                    show: true,
                    time: 10000,
                    text: res.data,
                    bottom: false,
                    right: true,
                    multi: true
                }
                this.local.openModalPushGeral = false
            }).finally(() =>{
                this.system.progress = false
            })
            this.resetPushGeralFields()
        },
        goPushTurma(id){
            const payload = {
                titulo: this.pushTurma.titulo,
                conteudo: this.pushTurma.texto,
                turma: id,
            }
            this.axios.post('admin/push/onesignal', payload).then(res => {
                this.system.AlertbarShow = {
                    show: true,
                    time: 10000,
                    text: res.data,
                    bottom: false,
                    right: true,
                    multi: true
                }
                this.local.openModalPushGeral = false
            }).finally(() =>{
                this.system.progress = false
            })
            this.resetPushTurmaFields()
        },
        getTituloTurma(descricao, gradeDescricao, idCurso){
          this.tituloCurso = descricao + " " + gradeDescricao
          this.idTurma = idCurso
        },
        resetPushGeralFields() {
            this.pushGeral.titulo = null;
            this.pushGeral.texto = null;
            this.local.openModalPushGeral = null;
        },
        resetPushTurmaFields() {
            this.pushTurma.titulo = null;
            this.pushTurma.texto = null;
            this.local.openModalPushTurma = null;
        }
    },
    mounted(){
        this.getCursos()
    }
}
</script>

<style>
.btn-disabled{
    opacity: 0.5;
    cursor: default;
    background-color: #2196f3;
}
</style>